import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9v5a5 5 0 0 0 10 0v-5","key":"svg-0"}],["path",{"d":"M5 5h14","key":"svg-1"}]]

/**
 * IconOverline
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItb3ZlcmxpbmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgOXY1YTUgNSAwIDAgMCAxMCAwdi01IiAvPgogIDxwYXRoIGQ9Ik01IDVoMTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/overline
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconOverline = createReactComponent('outline', 'overline', 'Overline', __iconNode);

export default IconOverline;